module.exports = __webpack_public_path__ + "img/largeScreenMapBgc.ec62d414.png";